import { render, staticRenderFns } from "./CatProp.vue?vue&type=template&id=bea56f3e&scoped=true"
import script from "./CatProp.vue?vue&type=script&lang=js"
export * from "./CatProp.vue?vue&type=script&lang=js"
import style0 from "./CatProp.vue?vue&type=style&index=0&id=bea56f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea56f3e",
  null
  
)

export default component.exports